
import ProductCard from '../../sections/Ecommerce/ProductCard';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import json from '../../data/Products-Ecomerce.json';
import Iconify from 'components/Iconify';
import Slider from "react-slick";
import '../../customStyles/console.css';
// intl
import { useIntl } from 'react-intl';
//redux
import { useSelector } from 'redux/store';

export default function ProductSection() {
    const intl = useIntl();
    const { environment } = useSelector((state) => state.nuDetectState);

    const menArrivals = json[0].products;
    const womenArrivals = json[1].products;
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 4
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1.5,
            partialVisibilityGutter: 30
        }
    };

    const carouselSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 3,
        autoplay: true,
        nextArrow: <></>,
        prevArrow: <></>,
        responsive: [
            {
                breakpoint: 4000,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 3000,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]
    };

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant='h3' display='flex' alignItems='center' fontSize={{ sm: 34, xs: 14 }} sx={{ color: 'black', mt: 3, mb: 2, fontWeight: 600 }}>
                    {intl.formatMessage({ id: 'home.texto-7', defaultMessage: 'Women - New Arrivals' })}
                </Typography>
                <Typography sx={{
                    color: '#4F4F4F', fontSize: { sm: 14, xs: 12 }, mt: 3, mb: 2, fontWeight: 600,
                    display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                    padding: '10px 8px', gap: '8px'
                }}>
                    {intl.formatMessage({ id: 'home.texto-16', defaultMessage: 'View All' })}
                    <Iconify icon='dashicons:arrow-right-alt2' />
                </Typography>
            </Box>
            <Grid>
                <Slider {...carouselSettings}>

                    {womenArrivals.map((item: any, key) => (

                        <ProductCard images={item.imagesUrls} key={key} image={item.imagesUrls[0]}
                            discountedPrice={item.discountedPrice} isFavorite={item.isFavorite}
                            percentageOff={item.percentageOff} price={item.price} productDescription={item.productDescription[environment?.language]}
                            productName={item.productName[environment?.language]} id={key} />
                    ))}
                </Slider>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant='h3' display='flex' alignItems='center' fontSize={{ sm: 34, xs: 14 }} sx={{ color: 'black', mt: 3, mb: 2, fontWeight: 600 }}>
                    {intl.formatMessage({ id: 'home.texto-8', defaultMessage: 'Men - New Arrivals' })}
                </Typography>
                <Typography sx={{
                    color: '#4F4F4F', fontSize: { sm: 14, xs: 12 }, mt: 3, mb: 2, fontWeight: 600,
                    display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                    padding: '10px 8px', gap: '8px'
                }}>
                    {intl.formatMessage({ id: 'home.texto-16', defaultMessage: 'View All' })}
                    <Iconify icon='dashicons:arrow-right-alt2' />
                </Typography>
            </Box>
            <Grid>
                <Slider {...carouselSettings}>
                    {menArrivals.map((item : any, key) => (
                        <ProductCard images={item.imagesUrls} key={key} image={item.imagesUrls[0]}
                            discountedPrice={item.discountedPrice} isFavorite={item.isFavorite}
                            percentageOff={item.percentageOff} price={item.price} productDescription={item.productDescription[environment?.language]}
                            productName={item.productName[environment?.language]} id={key} />
                    ))}
                </Slider>
            </Grid>
        </>
    )
}